require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-vancouvers-next-top-agent-website.json") })
        }
      }, "path---projects-vancouvers-next-top-agent-website");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-vancouvers-next-top-agent-website!./.cache/json/projects-vancouvers-next-top-agent-website.json
// module id = 534
// module chunks = 231608221292675